import React, { Component } from "react";
import axios from 'axios'
import { Table, Space, DatePicker } from "antd";
import moment from 'moment'
import MonthlySubTableArticles from './MonthlySubTableArticles'
import SelectInterval from "../Negozi/SelectInterval";
import MyResponsivePie from "./Torta";

const { RangePicker } = DatePicker;


export default class ArticleTable extends Component {
    constructor() {
        super();
        this.state = {
            dataSource: [],
            interval: "year",
            // "" means all negozi
            shop: "all",
            daily: [],
            start: moment().subtract(1, 'month').toISOString(),
            end: new Date().toISOString()
        };

        this.changeInterval = this.changeInterval.bind(this)
        this.selectNegozio = this.selectNegozio.bind(this)
        this.onDateChange = this.onDateChange.bind(this)
    }

    componentDidMount() {
        this.fetchShopsData()
    }

    fetchShopsData() {
        return axios
            .get(
                `${process.env.REACT_APP_SERVER_URL}/api/dati/articlesByNegozi?start=${this.state.start}&end=${this.state.end}&interval=${this.state.interval}`
            )
            .then((response) => {
                console.log(response)
                this.setState({ dataSource: response.data.articoli.buckets[0].negozi.buckets })
            })
            .catch((error) => {
                console.log(error);
            })
            .then(() => {
                // always executed
            });
    }


    changeInterval(interval) {
        this.setState({ interval }, () => {
            this.fetchShopsData()
        })

    }

    selectNegozio(shop) {


        this.setState({ shop })

        if (shop === "all") {
            this.fetchShopsData()
        } else {

            this.fetchShopsData().then(() =>
                this.setState({ dataSource: this.state.dataSource.filter(negozio => negozio.key === shop) })
            )
        }

    }

    onDateChange(dates) {

        this.setState({ start: dates[0].format("YYYY-MM-DD"), end: dates[1].format("YYYY-MM-DD") }, () => {
            this.fetchShopsData()
        })
    }


    generateFilters() {
        console.log(this.state.dataSource)
        return this.state.dataSource.map((article) => {
            return {
                text: article.key,
                value: article.key
            }
        })
    }


    render() {

        if (this.state.dataSource) {
            this.generateFilters()

            const yearly_columns = [
                {
                    title: "Articolo",
                    dataIndex: "key",
                    key: "key",
                    render: (text, row) => (
                        <Space size="middle" key={row.key}>
                            { row.key !== "" ? <p>{row.key}</p> : <p>Transazioni non collegate ad un negozio</p>}
                        </Space>
                    )
                },
                {
                    title: "Articolo",
                    dataIndex: "key",
                    key: "key",
                    filters: this.generateFilters(),
                    onFilter: (value, record) => record.key.indexOf(value) === 0,
                },
                {
                    title: "ProductId",
                    dataIndex: "key",
                    key: "key",
                    render: (text, row) => (
                        <Space size="middle" key={row.key}>
                            { row.per_negozio.buckets[0].articoli.buckets[0].productId}
                        </Space>
                    )
                }
            ]

            const dateFormat = "YYYY-MM-DD"

            return (
                <div id="analytics">

                    <div id="analytics_range_picker">

                        <RangePicker
                            defaultValue={[moment(this.state.start, dateFormat), moment(this.state.end, dateFormat)]}
                            onChange={this.onDateChange}
                            format={"DD-MM-YYYY"}
                        />

                    </div>

                    <div id="analytics_filters">
                        <SelectInterval changeInterval={this.changeInterval} />
                    </div>


                    <div id="analytics_torta">
                        <MyResponsivePie start={this.state.start} end={this.state.end} shop={this.state.shop} />
                    </div>


                    <Table id="analytics_table" pagination={true} dataSource={this.state.dataSource} expandable={{
                        expandedRowRender: record => <MonthlySubTableArticles pagination={true} data={record.per_negozio.buckets} negozio={record.key} interval={this.state.interval} />

                    }} columns={yearly_columns} />
                </div>
            )
        }
    }

}
